export default {"src":"/_next/static/media/phone.2bbcc3a1.svg","height":27,"width":30,"blurWidth":0,"blurHeight":0};